
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { GrievanceList } from '../grievance/GrievanceList';
import PlaceholderTabContent from '../dashboard/PlaceholderTabContent';

const LegalDepartmentPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState("grievances");

  return (
    <div className="space-y-6 p-6 pb-16 animate-fade-in">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Legal Department</h1>
        <p className="text-muted-foreground">
          Manage legal grievances, contracts, and compliance matters
        </p>
      </div>
      
      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="grievances">Grievances & Tickets</TabsTrigger>
          <TabsTrigger value="contracts">Contracts</TabsTrigger>
          <TabsTrigger value="compliance">Compliance</TabsTrigger>
        </TabsList>
        
        <TabsContent value="grievances" className="space-y-4">
          <GrievanceList />
        </TabsContent>
        
        <TabsContent value="contracts" className="space-y-4">
          <PlaceholderTabContent 
            title="Contract Management" 
            description="Manage and track all legal contracts and agreements." 
          />
        </TabsContent>
        
        <TabsContent value="compliance" className="space-y-4">
          <PlaceholderTabContent 
            title="Compliance Dashboard" 
            description="Monitor regulatory compliance and legal requirements." 
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default LegalDepartmentPage;
